import { UtilityBannerProps } from '@grubhubprod/gh-cookbook-react';
import { getUsagePercent } from 'src/common/utils/getUsagePercent';
import {
  BalanceBannerType,
  BalanceContextValue,
} from 'src/components/selfService/common/Balance/balance.types';
import { BalanceAccountStatus } from 'src/types/Balance';
import { getBalanceStatusBanner } from 'src/components/selfService/common/Balance/utils/getBalanceStatusBanner/getBalanceStatusBanner';
import {
  CREDIT_LIMIT_APPROACHING_THRESHOLD,
  MAX_CREDIT_LIMIT_PERCENTAGE,
} from 'src/components/selfService/common/Balance/constants/balanceConstants';

export const getActiveBalanceStatusBanner = (
  balanceContext: BalanceContextValue
): UtilityBannerProps | null => {
  const creditInfo = balanceContext.creditInfo;

  if (!creditInfo) {
    return getBalanceStatusBanner(BalanceBannerType.ServiceUnavailable);
  }

  if (creditInfo.accountStatus === BalanceAccountStatus.SUSPENDED) {
    return getBalanceStatusBanner(BalanceBannerType.SuspendedGeneric);
  }

  if (!creditInfo.creditLimit) {
    return null;
  }

  const usedCreditLimitPercentage = getUsagePercent(
    creditInfo.creditLimit - creditInfo.availableCredit,
    creditInfo.creditLimit
  );

  if (
    usedCreditLimitPercentage > CREDIT_LIMIT_APPROACHING_THRESHOLD &&
    usedCreditLimitPercentage < MAX_CREDIT_LIMIT_PERCENTAGE
  ) {
    return getBalanceStatusBanner(BalanceBannerType.CreditLimitApproaching, {
      usagePercent: usedCreditLimitPercentage,
    });
  }

  return null;
};
